import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonLoaderComponent } from '../button-loader/button-loader.component';
import { Observable } from 'rxjs';
import { NgIf } from '@angular/common';

@Component({
  selector: 'shared-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css'],
  standalone: true,
  imports: [ButtonLoaderComponent, NgIf],
})
export class GenericDialogComponent {
  @ViewChild('primaryButtonLoader') primaryButtonLoader!: ButtonLoaderComponent;
  @ViewChild('secondaryButtonLoader') secondaryButtonLoader!: ButtonLoaderComponent;

  @Input()
  primaryButtonText: string = "Aceptar";
  @Input()
  showSecondaryButton: boolean = true;
  @Input()
  secondaryButtonText: string = "Cancelar";

  constructor(
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      primaryObservable: Observable<any>,
      secondaryObservable: Observable<any>,
      validateForm: Function
     }
  ) {}

  onPrimaryButtonClick() {
    if (!this.data.primaryObservable) {
      this.close(true);
      return;
    }

    if (this.data.validateForm && !this.data.validateForm()) {
      return;
    }

    this.primaryButtonLoader.loading = true;
    this.data.primaryObservable.subscribe(() => {
      this.primaryButtonLoader.loading = false;
      this.close(true);
    });
  }

  onSecondaryButtonClick() {
    if (!this.data.secondaryObservable) {
      this.close(false);
      return;
    }
    this.secondaryButtonLoader.loading = true;
    this.data.secondaryObservable.subscribe(() => {
      this.secondaryButtonLoader.loading = false;
      this.close(false);
    });
  }

  close(result?: boolean): void {
    this.dialogRef.close(result);
  }
}
